import { CompactPill, Pill, REVIEW_TEAM_COLORS } from '@/components/shared/components/Pill';

import { REVIEW_TEAM_LABEL, ReviewTeam } from './conditionTemplates';

interface ReviewTeamPillProps {
    team: ReviewTeam;
    isCompact?: boolean;
}

export const ReviewTeamPill = ({ team, isCompact = false }: ReviewTeamPillProps) => {
    if (team === ReviewTeam.Unknown) return null;
    if (isCompact)
        return (
            <CompactPill colors={REVIEW_TEAM_COLORS[ReviewTeam[team]]}>
                {REVIEW_TEAM_LABEL[team]}
            </CompactPill>
        );
    return <Pill colors={REVIEW_TEAM_COLORS[ReviewTeam[team]]}>{REVIEW_TEAM_LABEL[team]}</Pill>;
};
